/*
 * Copyright (C) Fraunhofer IESE 2026
 *
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */

import { InvitationInvalidLogo } from 'assets';
import { FC } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

export const AlreadyMember: FC = () => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'invitationsPage.alreadyMember'
  });

  return (
    <>
      <Row>
        <Col>
          <p className="text-left">{t('description')}</p>
        </Col>
      </Row>
      <Row>
        <Col>
          <p className="text-left mt-4">{t('options')}</p>
        </Col>
      </Row>
      <Row>
        <Col className="text-center mt-5">
          <InvitationInvalidLogo />
        </Col>
      </Row>
    </>
  );
};
